import { faCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuItem } from "@mui/material";
import { MprcDropDownItemAny } from "components/MprcIconButtonDropdown";
import LibUtils from "lib/LibUtils";
import * as React from "react";

interface IProps {
    children?: React.ReactNode;
    item: MprcDropDownItemAny;
    selectedItem: any;
    onClick: (e: React.MouseEvent<HTMLLIElement, MouseEvent>, selection: MprcDropDownItemAny) => void;
}

export const MprcMenuItemCheck: React.FC<IProps> = (props) => {
    const { item, selectedItem, onClick, children } = props;

    return (
        <MenuItem onClick={(e) => onClick(e, item)} disabled={item.disabled}>
            {item.checked || LibUtils.deepCompare(selectedItem, item.value) ? (
                <React.Fragment>
                    <b>
                        <FontAwesomeIcon fixedWidth icon={faCheck} />
                    </b>
                </React.Fragment>
            ) : (
                <div className="fa fa-check fa-w-16 fa-fw"></div>
            )}
            {item.text || children}
        </MenuItem>
    );
};
